const getTablePlaceholders = (placeholdersCount) => {
  return new Array(placeholdersCount).fill({});
};

const tableUtils = { getTablePlaceholders };

export default tableUtils;
